import script from "./AvatarStat.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarStat.vue?vue&type=script&setup=true&lang=js"

import "./AvatarStat.vue?vue&type=style&index=0&id=4a44c784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a44c784"]])

export default __exports__